import { Button, Icon } from "@mindlercare/ui-web";
import { useDemo } from "contexts/DemoContext";
import { usePsychologistUser } from "hooks";
import React from "react";
import { useNavigate } from "react-router-dom";
import { styled } from "styled-components";

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export type PatientNameProps = {
  firstName: string | null;
  lastName: string | null;
  userId: number | null;
};

export const PatientName = ({ patient }: { patient?: PatientNameProps }) => {
  const { psychologist } = usePsychologistUser();
  const isDemo = useDemo();

  const navigate = useNavigate();
  const patientName = `${patient?.firstName ?? "<Unknown"} ${
    patient?.lastName ?? "Patient>"
  }`;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    // Prevent propagation to parent element which is a table row with
    // a different onClick logic.
    e.stopPropagation();
    e.preventDefault();

    if (!!psychologist.psychologistId && !!patient?.userId) {
      navigate(
        `/patients/psychologist/${psychologist?.psychologistId}/patient/${patient?.userId}/icbt`,
      );
    }
  };
  return (
    <Container>
      <Icon.Account color="GRAY" />
      <LinkButton
        maskText={isDemo}
        variant="neutral"
        color={"GRAY_BLACK"}
        onClick={handleClick}
      >
        {patientName}
      </LinkButton>
    </Container>
  );
};

const LinkButton = styled(Button)`
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
